<div class="stripe-connect">
  <span>Connect with</span>
</div>
